export default class Language {
    static get ENGLISH() {
        return {
            label: 'English',
            name: 'en',
            descrip_name: "descrip_en",
            address_name: "address_en",
            area_name: "area_en",
            facing: "Facing",
            unitPlaceholder: "Villa",
            catogoryPlaceholder: " Type Catogory Name",
            finishingPlaceholder:"Type Finishing Name",
            cityPlaceholder:"Type City Name",
            areaPlaceholder:"Type area Name",
            facilityPlaceholder:"Type Facility Name",
            rolePlaceholder:"Type Role Name",
            paymentPlaceholder:"Type payment Name",
            criteriaPlaceholder:"Type criteria Name",
            amenities: "Amenities"
        };
    }
    static get ARABIC() {
        return {
            label: 'Arabic',
            name: 'ar',
            descrip_name: "descrip_ar",
            address_name: "address_ar",
            area_name: "area_ar",
            unitPlaceholder: "فيلا",
            facing:"الواجهة",
            catogoryPlaceholder: "طبقة",
            finishingPlaceholder:"التشطيب",
            cityPlaceholder:" المدينة",
            areaPlaceholder:"المنطقة",
            facilityPlaceholder:"خدمة",
            rolePlaceholder:"منصب",
            paymentPlaceholder:"الدفع",
            criteriaPlaceholder:"اسم المعايير",
            amenities: "وسائل الراحة",
        };
    }

    static get RUSSIAN() {
        return {
            label: 'Russian',
            name: 'ru',
            descrip_name: "descrip_ru",
            address_name: "address_ru",
            area_name: "area_ru",
            unitPlaceholder: "Вилла",
            catogoryPlaceholder: "Тип Категория Название",
            finishingPlaceholder:"Тип Название отделки",
            cityPlaceholder:"Тип Название города",
            areaPlaceholder:"Тип области Имя",
            facilityPlaceholder:"Тип Название объекта",
            rolePlaceholder:"Тип Имя роли",
            paymentPlaceholder:"Введите название платежа",
            criteriaPlaceholder:"Критерии типа Имя",
            facing: "Облицовка",
            amenities: "удобства"
        }
    }

    static get CHINESE() {
        return {
            label: 'Chinese',
            name: 'zh',
            descrip_name: "descrip_zh",
            address_name: "address_zh",
            area_name: "area_zh",
            unitPlaceholder: "別墅",
            catogoryPlaceholder: " 類型類別名稱",
            finishingPlaceholder:"類型精加工名稱",
            cityPlaceholder:"輸入城市名稱",
            areaPlaceholder:"輸入區域名稱",
            facilityPlaceholder:"輸入設施名稱",
            rolePlaceholder:"鍵入角色名稱",
            paymentPlaceholder:"輸入付款名稱",
            criteriaPlaceholder:"類型標準名稱",
            facing:"面对",
            amenities: "设施"
        };
    }
    static get LIST() {
        return [
            Language.ENGLISH,
            Language.ARABIC,
            Language.RUSSIAN,
            Language.CHINESE,
        ];
    }
}
